export default __webpack_public_path__ + "static/media/webix.dc98a7d7.svg";